import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.wHeight = window.innerHeight;
        this.parallaxSpeed = parseFloat(this.el.dataset.scrollSpeed);

        this.computeScale();
        window.addEventListener("resize", this.onResize.bind(this));
    }

    onResize() {
        this.wHeight = window.innerHeight;
        this.computeScale();
    }

    computeScale() {
        const elHeight = this.el.offsetHeight;
        const distance = Math.abs(this.wHeight * this.parallaxSpeed / 1.5);
        const scale = 1 + distance / elHeight;
        this.el.style.setProperty("--parallax-scale", scale);
    }
}
